type FlagProps = {
  flagSrc: string;
  className?: string;
};

export function Flag({ flagSrc, className }: Readonly<FlagProps>) {
  return (
    <img
      src={flagSrc}
      alt='Flag'
      className={`rounded-full shadow-sm object-cover ${className ?? 'w-8 h-8'}`}
    />
  );
}
